import { UserIdSchema as n, AdFormatIdSchema as o, AdTypeIdSchema as a, SpotIdSchema as i, ContentTypeIdSchema as r } from "@hprofits/shared";
import { z as e } from "zod";
import { PaginationSchema as m, paginatedList as d } from "../common/pagination.js";
import { idListQueryParam as t } from "../common/params.js";
const c = 100, g = m.extend({
  pageSize: e.coerce.number().int().min(1).max(c).default(50),
  search: e.string().trim().min(1).optional(),
  ids: t(i).optional(),
  typeIds: t(a).optional(),
  formatIds: t(o).optional(),
  ownerIds: t(n).optional(),
  // No branded site id exists in @hprofits/shared yet, unlike the other filters here.
  siteIds: t(e.int().positive()).optional()
}).readonly(), s = e.object({
  id: a,
  name: e.string()
}).readonly(), l = e.object({
  id: o,
  name: e.string()
}).readonly(), p = e.object({
  id: r,
  name: e.string()
}).readonly(), S = e.object({
  id: n,
  email: e.string()
}).readonly(), y = e.object({
  id: i,
  name: e.string(),
  type: s,
  format: l.nullable(),
  contentType: p.nullable(),
  owner: S.nullable(),
  createdAt: e.string()
}).readonly(), b = d(y);
export {
  c as AD_UNITS_MAX_PAGE_SIZE,
  y as AdUnitItemSchema,
  g as AdUnitsQuerySchema,
  b as AdUnitsResponseSchema
};
//# sourceMappingURL=schemas.js.map
